// extracted by mini-css-extract-plugin
export default {"root":"StageScaler_root_MHPB9","cellphone":"StageScaler_cellphone_v101e"};